/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FormInputFieldComponent = {
  id?: number
  label?: string
  inputType?: FormInputFieldComponent.inputType
  required?: boolean
  options?: any
}
export namespace FormInputFieldComponent {
  export enum inputType {
    TEXT = 'text',
    TEXTAREA = 'textarea',
    CHECKBOX = 'checkbox',
    EMAIL = 'email',
    RADIO = 'radio',
  }
}
